import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ENVIRONMENT } from "./Common/behaviour";
import registerServiceWorker from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, compose, combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';
import rootSaga from './Sagas/rootSaga';
import LeaderboardReducer from './Reducers/LeaderboardReducer.js';
import UserReducer from './Reducers/UserReducer.js';
<link rel="icon" href="http://134.209.230.231/img/images/GolfSnapshot_liggande_svart.png"></link>
//<link rel="stylesheet" href="https://use.typekit.net/mmo2nyp.css"></link>
const allReducers = combineReducers({leaderboard:LeaderboardReducer, userData:UserReducer});
const sagaMiddleware = createSagaMiddleware();
const allStoreEnhancers = window.navigator.userAgent.includes('Chrome') && window.devToolsExtension && ENVIRONMENT.DEV
    ? compose(
            applyMiddleware(sagaMiddleware),
            window.devToolsExtension && window.devToolsExtension()
        )
    : applyMiddleware(sagaMiddleware);
const store = createStore(
    allReducers,
    {},
    allStoreEnhancers
);
sagaMiddleware.run(rootSaga);







ReactDOM.render((
    <HashRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </HashRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js